export const projectsData = [
  {
    id: 1,
    title: "Mika Crypto",
    date: "Juin 2023",
    languages: ["React", "Redux", "Sass"],
    infos:
      "Le tableau de bord ultime pour suivre et analyser les tendances des cryptomonnaies, exclusivement sur Mika Crypto.",
    img: "./assets/img/projet-1.jpg",
    link: "https://michael-silliau.github.io/mika-crypto/",
  },
  {
    id: 2,
    title: "Mika Travel",
    date: "Janvier 2023",
    languages: ["Html", "css"],
    infos:
      "Bienvenue dans l'univers époustouflant des montagnes : Explorez, rêvez, et découvrez des paysages magnifiques !",
    img: "./assets/img/projet-2.jpg",
    link: "https://michael-silliau.github.io/mika-travel/",
  },
  {
    id: 3,
    title: "React-form-login",
    date: "Février 2023",
    languages: ["React", "css"],
    infos: "Work in Progress !!!   Page de connexion design en React.",
    img: "./assets/img/projet-3.jpg",
    link: "http://www.google.com",
  },
  {
    id: 4,
    title: "Flags World",
    date: "Mai 2023",
    languages: ["React", "Sass"],
    infos: "Dashboard regroupant tous les drapeaux du monde.",
    img: "./assets/img/projet-4.jpg",
    link: "https://michael-silliau.github.io/Flags-World/",
  },
];
